import {Stack} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';


const iconStyle = {
    '&:hover': {
        color: 'rgb(107,105,105)',
    },
}

export default function PromotionalLinksAction(adsLinks, setId, setName, setDeleteOpen){
    return adsLinks.map((item, i) => (
            <Stack key={i}
                   direction={"row"} justifyContent={'space-evenly'}>
                <Stack onClick={() => {
                    navigator.clipboard.writeText(item.link)
                }}><ContentCopyIcon sx={iconStyle} /></Stack>
                <Stack><DeleteIcon sx={iconStyle} onClick={()=>{
                    setName(item.name)
                    setId(item.id)
                    setDeleteOpen(true)}} /></Stack>
            </Stack>
        ))
}
